/**
 * batchApi: Handling Batch API Requests, where backend  has limits on how many you can request at a time.
 */
const convertArrayToBatches = (array, sizePerBatch = 200) => {
    const batches = [];
    for (let i = 0; i < array.length; i += sizePerBatch) {
        batches.push(array.slice(i, i + sizePerBatch));
    }
    return batches;
};

/**
 * createBatchSizesFromNumber: convert a total number into batch limits based on sizePerBatch
 * e.g. (number = 534, sizePerBatch = 200) = [200, 200, 134]
 * @param {Int} number
 * @param {Int} sizePerBatch
 * @returns
 */
const createBatchSizesFromNumber = (number, sizePerBatch = 200) => {
    let fullSetsCount = Math.floor(number / sizePerBatch);
    let lastSetSize = number % sizePerBatch;

    let chunksArray = [];

    // Add full sets
    for (let i = 0; i < fullSetsCount; i++) {
        chunksArray.push(sizePerBatch);
    }

    // Add the last set
    if (lastSetSize > 0) {
        chunksArray.push(lastSetSize);
    }

    return chunksArray;
};
/**
 * mergeArrays
 * Shared chunkPromises promisesRespHandler for getBatchPhotoCounts and fetchUploadIds
 */
const mergeArrays = arrayOfArrays => {
    return [].concat(...arrayOfArrays);
};

/**
 * calls: executes all promises
 * @param {Array} array
 * @param {Function} promiseHandler
 * @returns
 */
const calls = async (array, promiseHandler) => {
    return await Promise.all(array.map(promiseHandler));
};

export default {
    convertArrayToBatches,
    createBatchSizesFromNumber,
    mergeArrays,
    calls
};
